module.exports = __webpack_public_path__ + "static/img/icon@2x.61d4f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/icon@2x.png
// module id = HjXd
// module chunks = 70